import { breakpoints } from '@/styles/breakpoints'
import { HeadingLabel, MetaDataLabel, SubheadingLabel } from '@/styles/fonts'
import { GrandstandIcon } from '@grandstand-web/bally-web-shared/src/components/GrandstandIcon'
import { PurchaseHistoryResponse } from '@grandstand/presentation-models'
import { useRouter } from 'next/router'
import styled from 'styled-components'

type PackagesProps = {
  hasPurchases: boolean
  availableCredits: number | null
  purchaseHistory: PurchaseHistoryResponse | null
}

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const Header = styled(HeadingLabel)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-right: 25px;
  border-bottom: 1px solid var(--divider-canvas);
  padding-bottom: 25px;
  padding-left: 25px;
  padding-top: 25px;
  cursor: pointer;
`

const Heading = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  ${breakpoints.down('sm')} {
    font-size: var(--heading-2-size);
  }
`
const ArrowIcon = styled(GrandstandIcon)``

const Row = styled.div`
  ${breakpoints.down('sm')} {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  ${breakpoints.up('md')} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  width: 100%;
  border-bottom: 1px solid var(--divider-canvas);
  padding: 25px;
  div {
    position: relative;
  }
`
interface ColProps {
  end?: boolean
}
const Col = styled(MetaDataLabel)<ColProps>`
  display: flex;
  align-items: center;
  text-align: left;
  ${breakpoints.up('md')} {
    ${(props) =>
      props.end &&
      `
    justify-self: end;
  `}
  }
`

const Label = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: 8px;
  border-radius: 2px;
  line-height: var(--button-sm-size);
  text-transform: uppercase;
  background-color: var(--fdsn-blue);
  font-size: var(--button-sm-size);
  font-weight: var(--button-font-weight);
`

const NoPurchases = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`

const SingleGames = ({ hasPurchases, availableCredits, purchaseHistory }: PackagesProps) => {
  const router = useRouter()

  const handleBackClick = () => {
    router.back()
  }

  return (
    <MainContent>
      <Header onClick={handleBackClick} fontSize="4">
        <Heading>
          <ArrowIcon icon="arrow_left" />
          <div>Single Games</div>
        </Heading>
        {!!availableCredits && <Label>{`${availableCredits} Available`}</Label>}
      </Header>
      {purchaseHistory && hasPurchases ? (
        purchaseHistory.redemption_history.map((item, i) => (
          <Row key={i}>
            <Col fontSize="sm">{item.status}</Col>
            <Col fontSize="sm">{item.description || '-'}</Col>
            <Col fontSize="sm" end>
              {new Date(item.date).toLocaleDateString('en-US', {
                year: '2-digit',
                month: '2-digit',
                day: '2-digit',
              })}
            </Col>
          </Row>
        ))
      ) : (
        <NoPurchases>
          <HeadingLabel fontSize="2">Get in the games.</HeadingLabel>
          <SubheadingLabel fontSize="2">
            Browse our lineup of live NBA and NHL games available for purchase.
          </SubheadingLabel>
        </NoPurchases>
      )}
    </MainContent>
  )
}
export default SingleGames
